import {BaseBlock, theme} from "../../../framework/js/core";
import {SimpleGoogleMap} from "../../../framework/plugins/SimpleGoogleMap/SimpleGoogleMap";

export class Map extends BaseBlock {
  constructor(root) {
    super(root);
    
    this.map = SimpleGoogleMap.create(this.root.find(".google-map__map"));
    this.map.newMap({});
  }
}